/**
 * Product Form LOP - JavaScript para funcionalidad de swatches en formulario de producto
 * Versión: 1.0.0
 * Autor: LOP Development Team
 */

(function() {
  'use strict';

  // Configuración
  const LOP_CONFIG = {
    navigationDelay: 300,
    loadingClass: 'loading',
    errorClass: 'error'
  };

  // Clases CSS
  const LOP_CLASSES = {
    swatchItem: 'LOP-product-form-swatch-item',
    swatchLink: 'LOP-product-form-swatch-link',
    swatchImage: 'LOP-product-form-swatch-image'
  };

  /**
   * Clase principal para manejar Product Form LOP
   */
  class ProductFormLOP {
    constructor() {
      this.initialized = false;
      this.init();
    }

    /**
     * Inicializar la funcionalidad
     */
    init() {
      if (this.initialized) return;
      
      this.bindEvents();

      console.log('[PDP Validación] Inicio');
      
      // Validar placeholders de swatches de inmediato
      this.loadMissingProductData();
      
      // Reintentar por si el DOM no estaba completo
      setTimeout(() => this.loadMissingProductData(), 1000);
      setTimeout(() => this.loadMissingProductData(), 3000);
      
      this.initialized = true;
      console.log('Product Form LOP inicializado');
    }

    /**
     * Vincular eventos
     */
    bindEvents() {
      // Helper: e.target puede ser un nodo de texto (no tiene .closest)
      const getTargetElement = (e) => {
        const t = e.target;
        return t && t.nodeType === 1 ? t : (t ? t.parentElement : null);
      };

      // Eventos de click en swatches
      document.addEventListener('click', (e) => {
        const el = getTargetElement(e);
        if (el && el.closest(`.${LOP_CLASSES.swatchItem}`)) {
          this.handleSwatchClick(e);
        }
      });

      // Eventos de hover para tooltips
      document.addEventListener('mouseenter', (e) => {
        const el = getTargetElement(e);
        if (el && el.closest(`.${LOP_CLASSES.swatchItem}`)) {
          this.handleSwatchHover(e);
        }
      }, true);

      // Eventos de focus para accesibilidad
      document.addEventListener('focusin', (e) => {
        const el = getTargetElement(e);
        if (el && el.closest(`.${LOP_CLASSES.swatchItem}`)) {
          this.handleSwatchFocus(e);
        }
      });

      // Soporte para contenido dinámico/AJAX
      this.observeDOMChanges();
    }

    /**
     * Manejar click en swatch
     */
    handleSwatchClick(e) {
      const targetEl = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
      const swatchItem = targetEl && targetEl.closest(`.${LOP_CLASSES.swatchItem}`);
      if (!swatchItem) return;

      // Intentar obtener la URL del enlace primero (ya está limpia)
      const swatchLink = swatchItem.querySelector(`.${LOP_CLASSES.swatchLink}`);
      let productUrl = null;
      
      if (swatchLink && swatchLink.href && swatchLink.href !== '#' && swatchLink.href !== window.location.href) {
        productUrl = swatchLink.href;
      } else {
        // Si no hay enlace válido, usar el handle del dataset (limpiándolo)
        let productHandle = swatchItem.dataset.productHandle;
        if (!productHandle) {
          console.error('Product Form LOP: No se encontró product handle');
          return;
        }
        
        // Limpiar espacios al inicio y final del handle
        productHandle = productHandle.trim();
        if (!productHandle) {
          console.error('Product Form LOP: Handle vacío después de limpiar');
          return;
        }
        
        productUrl = `/products/${productHandle}`;
      }

      // Verificar si es el producto actual
      const isCurrentProduct = swatchItem.classList.contains('LOP-product-form-swatch-item--current');
      if (isCurrentProduct) {
        // Si es el producto actual, solo mostrar un mensaje o hacer scroll suave
        console.log('Product Form LOP: Ya estás viendo este producto');
        return;
      }

      // Prevenir el comportamiento por defecto
      e.preventDefault();
      e.stopPropagation();

      // Añadir clase de carga
      swatchItem.classList.add(LOP_CONFIG.loadingClass);

      // Navegar al producto después del delay
      setTimeout(() => {
        try {
          window.location.href = productUrl;
        } catch (error) {
          console.error('Product Form LOP: Error al navegar:', error);
          swatchItem.classList.remove(LOP_CONFIG.loadingClass);
          swatchItem.classList.add(LOP_CONFIG.errorClass);
        }
      }, LOP_CONFIG.navigationDelay);
    }

    /**
     * Manejar hover en swatch
     */
    handleSwatchHover(e) {
      const targetEl = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
      const swatchItem = targetEl && targetEl.closest(`.${LOP_CLASSES.swatchItem}`);
      if (!swatchItem) return;

      // Tooltip ya está manejado por CSS
      // Aquí se pueden añadir funcionalidades adicionales
    }

    /**
     * Manejar focus en swatch
     */
    handleSwatchFocus(e) {
      const targetEl = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
      const swatchItem = targetEl && targetEl.closest(`.${LOP_CLASSES.swatchItem}`);
      if (!swatchItem) return;

      // Asegurar que el swatch sea visible
      swatchItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /**
     * Observar cambios en el DOM para contenido dinámico
     */
    observeDOMChanges() {
      if (!window.MutationObserver) return;

      const observer = new MutationObserver((mutations) => {
        let shouldReinit = false;
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList && node.classList.contains(LOP_CLASSES.swatchItem)) {
                  shouldReinit = true;
                }
                if (node.querySelector && node.querySelector(`.${LOP_CLASSES.swatchItem}`)) {
                  shouldReinit = true;
                }
              }
            });
          }
        });

        if (shouldReinit) {
          // Los swatches ya están funcionando, no necesitamos reinicializar
          // pero podemos loguear para debugging
          console.log('Product Form LOP: Nuevos swatches detectados');
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    /**
     * Crear swatch programáticamente
     */
    createSwatch(productData) {
      const { handle, title, image, tooltip } = productData;
      
      const swatchItem = document.createElement('div');
      swatchItem.className = LOP_CLASSES.swatchItem;
      swatchItem.dataset.productHandle = handle;
      
      if (tooltip) {
        swatchItem.dataset.tooltip = tooltip;
      }

      const swatchLink = document.createElement('a');
      swatchLink.className = LOP_CLASSES.swatchLink;
      swatchLink.href = `/products/${handle}`;
      swatchLink.setAttribute('aria-label', `Ver ${title}`);

      const swatchImage = document.createElement('img');
      swatchImage.className = LOP_CLASSES.swatchImage;
      swatchImage.src = image;
      swatchImage.alt = title;
      swatchImage.loading = 'lazy';

      swatchLink.appendChild(swatchImage);
      swatchItem.appendChild(swatchLink);

      return swatchItem;
    }

    /**
     * Añadir swatches a un contenedor
     */
    addSwatchesToContainer(container, products) {
      if (!container || !products || !Array.isArray(products)) return;

      products.slice(0, 5).forEach((product) => {
        const swatch = this.createSwatch(product);
        container.appendChild(swatch);
      });
    }

    /**
     * Obtener swatches existentes
     */
    getSwatches() {
      return document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
    }

    /**
     * Verificar si un elemento es un swatch
     */
    isSwatch(element) {
      return element && element.classList && element.classList.contains(LOP_CLASSES.swatchItem);
    }

    /**
     * Obtener información del producto desde un swatch
     */
    getProductInfoFromSwatch(swatchItem) {
      if (!this.isSwatch(swatchItem)) return null;

      return {
        handle: swatchItem.dataset.productHandle,
        title: swatchItem.querySelector('img')?.alt || '',
        image: swatchItem.querySelector('img')?.src || '',
        tooltip: swatchItem.dataset.tooltip || ''
      };
    }

    /**
     * Cargar datos de un producto
     */
    loadProductData(handle) {
      return fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            console.log(`[PDP Validación] Fetch ${response.status}: ${handle}`);
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .catch(error => {
          console.error(`Product Form LOP: Error cargando datos de ${handle}:`, error);
          return null;
        });
    }

    /**
     * Ocultar swatch permanentemente (PDP: sin espacio, sin cuadrado visible)
     */
    hideSwatch(swatch) {
      if (!swatch) return;
      if (swatch.dataset.hidden === 'true') return;

      const handle = swatch.dataset.productHandle || '(sin handle)';
      console.log(`[PDP Validación] hideSwatch: ${handle}`);

      swatch.dataset.hidden = 'true';
      swatch.classList.add('LOP-swatch-hidden-permanently');

      // Ocultar completamente (inline + important para ganar a cualquier CSS)
      swatch.style.setProperty('display', 'none', 'important');
      swatch.style.setProperty('visibility', 'hidden', 'important');
      swatch.style.setProperty('opacity', '0', 'important');
      swatch.style.setProperty('height', '0', 'important');
      swatch.style.setProperty('width', '0', 'important');
      swatch.style.setProperty('min-height', '0', 'important');
      swatch.style.setProperty('min-width', '0', 'important');
      swatch.style.setProperty('margin', '0', 'important');
      swatch.style.setProperty('padding', '0', 'important');
      swatch.style.setProperty('overflow', 'hidden', 'important');
      swatch.style.setProperty('border', 'none', 'important');
      swatch.style.setProperty('border-width', '0', 'important');

      const link = swatch.querySelector('.LOP-product-form-swatch-link');
      if (link) {
        link.style.setProperty('display', 'none', 'important');
        link.style.setProperty('pointer-events', 'none', 'important');
        link.href = '#';
      }

      const img = swatch.querySelector('.LOP-product-form-swatch-image');
      if (img) {
        img.style.setProperty('display', 'none', 'important');
      }
    }

    /**
     * Actualizar swatch con datos del producto
     */
    updateSwatchWithProductData(swatch, productData) {
      if (!productData || !swatch) return;

      // Verificar si el producto está disponible
      if (!productData.available) {
        console.log(`Product Form LOP: Producto ${productData.title} no está disponible, ocultando swatch`);
        this.hideSwatch(swatch);
        return;
      }

      // Verificar si tiene variantes disponibles
      const hasAvailableVariant = productData.variants && productData.variants.some(v => v.available);
      if (!hasAvailableVariant) {
        console.log(`Product Form LOP: Producto ${productData.title} no tiene variantes disponibles, ocultando swatch`);
        this.hideSwatch(swatch);
        return;
      }

      // Verificar si el producto está publicado (no en borrador)
      if (productData.published_at === null || productData.published_at === '') {
        console.log(`Product Form LOP: Producto ${productData.title} está en borrador, ocultando swatch`);
        this.hideSwatch(swatch);
        return;
      }

      const swatchImage = swatch.querySelector('.LOP-product-form-swatch-image');
      if (!swatchImage) return;

      // Revelar el swatch (la clase CSS se encarga de mostrarlo)
      swatch.classList.add('LOP-pdp-swatch-validated');
      swatch.classList.remove('LOP-swatch-hidden', 'LOP-product-form-swatch-fallback');
      swatch.style.removeProperty('display');
      swatch.style.removeProperty('visibility');
      swatch.style.removeProperty('opacity');
      swatch.style.removeProperty('height');
      swatch.style.removeProperty('width');
      swatch.style.removeProperty('margin');
      swatch.style.removeProperty('padding');
      swatch.style.removeProperty('overflow');
      swatch.style.removeProperty('border');

      // Obtener la mejor imagen disponible
      let imageUrl = null;
      let imageAlt = productData.title || 'Producto';

      if (productData.featured_image) {
        imageUrl = productData.featured_image;
      } else if (productData.images && productData.images.length > 0) {
        imageUrl = productData.images[0];
      }

      if (imageUrl) {
        // Crear nueva imagen
        const newImg = document.createElement('img');
        newImg.src = imageUrl;
        newImg.alt = imageAlt;
        newImg.className = 'LOP-product-form-swatch-image';
        newImg.loading = 'lazy';
        
        // Obtener tamaño de variant_image_size del estilo inline o usar default
        const container = swatch.closest('.product-form__input--color');
        let imageSize = '84'; // default
        if (container) {
          const sizeMatch = container.className.match(/product-form__input--color--(\w+)/);
          if (sizeMatch) {
            const sizeMap = { regular: '84', large: '120', xlarge: '160' };
            imageSize = sizeMap[sizeMatch[1]] || '84';
          }
        }
        newImg.width = imageSize;
        newImg.height = imageSize;
        
        // Añadir evento de error para fallback
        newImg.addEventListener('error', () => {
          console.warn(`Product Form LOP: Error cargando imagen para ${productData.title}`);
          swatch.classList.add('LOP-product-form-swatch-loading');
        });
        
        // Añadir evento de carga exitosa
        newImg.addEventListener('load', () => {
          console.log(`Product Form LOP: Imagen cargada exitosamente para ${productData.title}`);
          swatch.classList.remove('LOP-loading', 'LOP-product-form-swatch-fallback', 'LOP-product-form-swatch-loading');
          swatch.classList.add('LOP-loaded');
        });
        
        // Reemplazar el contenido del swatch
        if (swatchImage.parentNode) {
          swatchImage.parentNode.replaceChild(newImg, swatchImage);
        }
        
        // Actualizar tooltip y datos
        if (productData.title) {
          swatch.dataset.tooltip = productData.title;
        }
        
        // Actualizar color del producto si está disponible
        if (productData.options && productData.options.length > 0) {
          const firstOption = productData.options[0];
          if (firstOption.values && firstOption.values.length > 0) {
            swatch.dataset.productColor = firstOption.values[0];
          }
        }
        
        // Actualizar URL del enlace
        const swatchLink = swatch.querySelector('.LOP-product-form-swatch-link');
        if (swatchLink && productData.url) {
          swatchLink.href = productData.url;
          // También actualizar el dataset con el handle limpio
          if (productData.handle) {
            swatch.dataset.productHandle = productData.handle.trim();
          }
        }
        
        // Actualizar disponibilidad y marcar como validado
        swatch.dataset.productAvailable = 'true';
        swatch.dataset.needsLoading = 'false';
        swatch.removeAttribute('data-needs-loading');
        
        // Actualizar estilo con imagen
        swatch.style.setProperty('--option-color-image', `url('${imageUrl}')`);
        
        console.log(`Product Form LOP: Swatch actualizado con datos de ${productData.title}`);
      } else {
        // No hay imagen disponible, ocultar swatch
        console.log(`Product Form LOP: Producto ${productData.title} no tiene imagen, ocultando swatch`);
        this.hideSwatch(swatch);
      }
    }

    /**
     * Cargar productos faltantes
     */
    loadMissingProductData() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}[data-needs-loading="true"]`);
      
      if (swatches.length === 0) {
        console.log('[PDP Validación] No hay swatches con data-needs-loading="true"');
        return Promise.resolve();
      }

      console.log(`[PDP Validación] Cargando ${swatches.length} swatches (placeholders)...`);

      const loadPromises = Array.from(swatches).map(swatch => {
        let handle = swatch.dataset.productHandle;
        if (!handle) return Promise.resolve();
        
        handle = handle.trim();
        if (!handle) return Promise.resolve();

        return this.loadProductData(handle)
          .then(productData => {
            if (productData) {
              this.updateSwatchWithProductData(swatch, productData);
              console.log(`[PDP Validación] MOSTRADO: ${handle} (${productData.title})`);
            } else {
              console.log(`[PDP Validación] OCULTO: ${handle} - 404 o error`);
              this.hideSwatch(swatch);
            }
          })
          .catch(err => {
            console.error(`[PDP Validación] Error validando ${handle}:`, err);
            this.hideSwatch(swatch);
          });
      });

      return Promise.all(loadPromises).then(() => {
        console.log('[PDP Validación] Carga completada');
        this.hideSwatchesStillLoading();
      });
    }

    /**
     * Ocultar swatches que siguen en estado loading sin imagen (p. ej. Liquid los mostró pero falló la imagen)
     */
    hideSwatchesStillLoading() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      swatches.forEach(swatch => {
        if (swatch.dataset.hidden === 'true') return;
        if (swatch.classList.contains('LOP-product-form-swatch-item--current')) return;
        const hasImg = swatch.querySelector('.LOP-product-form-swatch-image[src]') || swatch.querySelector('img.LOP-product-form-swatch-image');
        const isLoading = swatch.querySelector('.LOP-product-form-swatch-loading');
        if (!hasImg && isLoading) {
          console.log(`[PDP Validación] Swatch sin imagen (loading): ${swatch.dataset.productHandle}, ocultando`);
          this.hideSwatch(swatch);
        }
      });
    }

    /**
     * Verificar formato de metafields desde JavaScript
     */
    debugMetafieldFormat() {
      console.log('Product Form LOP: Verificando formato de metafields...');
      
      // Buscar elementos de debug en el DOM
      const debugElements = document.querySelectorAll('[style*="display: none"]');
      let debugInfo = null;
      
      debugElements.forEach(element => {
        if (element.textContent.includes('Debug Product Form - Agrupador Original:')) {
          debugInfo = element.textContent;
        }
      });
      
      if (debugInfo) {
        console.log('Product Form LOP: Información de debug encontrada:', debugInfo);
        
        // Extraer información específica
        const originalMatch = debugInfo.match(/Debug Product Form - Agrupador Original: ([^\n]+)/);
        const handlesMatch = debugInfo.match(/Debug Product Form - Handles Encontrados: ([^\n]+)/);
        
        if (originalMatch) {
          console.log('Product Form LOP: Formato original:', originalMatch[1].trim());
        }
        if (handlesMatch) {
          console.log('Product Form LOP: Handles encontrados:', handlesMatch[1].trim());
        }
      } else {
        console.log('Product Form LOP: No se encontró información de debug en el DOM');
      }
      
      // Verificar swatches existentes
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Form LOP: Swatches encontrados: ${swatches.length}`);
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const color = swatch.dataset.productColor;
        const isCurrent = swatch.dataset.isCurrentProduct;
        
        console.log(`Product Form LOP: Swatch ${index + 1}:`, {
          handle: handle,
          color: color,
          isCurrent: isCurrent,
          hasImage: !!swatch.querySelector('img')
        });
      });
      
      return {
        debugInfo: debugInfo,
        swatchesCount: swatches.length
      };
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.ProductFormLOP = new ProductFormLOP();
    });
  } else {
    window.ProductFormLOP = new ProductFormLOP();
  }

  // Exponer la clase para uso externo
  window.ProductFormLOPClass = ProductFormLOP;

  // Función de utilidad para inicialización manual
  window.initProductFormLOP = function() {
    if (!window.ProductFormLOP) {
      window.ProductFormLOP = new ProductFormLOP();
    }
    return window.ProductFormLOP;
  };

  // Exponer funciones para debugging
  window.debugProductFormLOP = function() {
    if (window.ProductFormLOP) {
      return window.ProductFormLOP.debugMetafieldFormat();
    } else {
      console.log('Product Form LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar formato de metafields
  window.debugProductFormMetafields = function() {
    if (window.ProductFormLOP) {
      return window.ProductFormLOP.debugMetafieldFormat();
    } else {
      console.log('Product Form LOP: Instancia no encontrada');
      return null;
    }
  };

})(); 